import { LaytimeTerms } from '@shared/utils/constants';
import type {
	CargoStats,
	CargoWithPortsAndCalculationsFromDb,
	CargoWithPortsAndCalculationsJSON,
} from '@api/features/laytime/getCargosAndLaytimes';
import {
	calculateAveragedLaytime,
	calculateNonReversibleLaytime,
	calculateReversibleLaytime,
} from './laytimeCalculations';

const getLaytimeStats = (
	cargo: CargoWithPortsAndCalculationsJSON | CargoWithPortsAndCalculationsFromDb,
	includeSettlement = true,
) => {
	let stats: CargoStats = {
		totalDemurrage: null,
		totalDespatch: null,
		totalReceivable: null,
		totalTimeDiff: 0,
		totalTimeLoading: null,
		totalTimeDischarging: null,
		totalDemurrageLoading: null,
		totalDemurrageDischarging: null,
		totalDespatchLoading: null,
		totalDespatchDischarging: null,
		calculatedDemurrage: null,
		calculatedDespatch: null,
		calculatedDemurrageLoading: null,
		calculatedDemurrageDischarging: null,
		calculatedDespatchLoading: null,
		calculatedDespatchDischarging: null,
		timeDiffLoading: null,
		timeDiffDischarging: null,
		details: [],
		isSettlement: false,
		isSettlementLoading: false,
		isSettlementDischarging: false,
	};

	const { laytimeTerms } = cargo;

	switch (laytimeTerms) {
		case LaytimeTerms.REVERSIBLE:
			stats = calculateReversibleLaytime(cargo, stats, includeSettlement);
			break;
		case LaytimeTerms.NON_REVERSIBLE:
			stats = calculateNonReversibleLaytime(cargo, stats, includeSettlement);
			break;
		case LaytimeTerms.AVERAGED:
			stats = calculateAveragedLaytime(cargo, stats, includeSettlement);
			break;
		default:
			break;
	}

	return stats;
};

export default getLaytimeStats;
